import { Trash2 } from 'lucide-react';

import IconButton from '@/components/Button/IconButton';
import useUserRole from '@/hooks/domain/useUserRole';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';
import useDetailModalStore from '@/stores/pure/DetailModalStore';
import { usePopup } from '@/stores/pure/PopupStore';
import useToastStore from '@/stores/pure/ToastStore';

export const FeedbackDeleteAction = ({
  feedbackAlias,
}: {
  feedbackAlias: string;
}) => {
  const { isEditor } = useUserRole();
  const addDefaultToast = useToastStore((state) => state.addDefaultToast);
  const removeFeedback = useFeedbackListStore((state) => state.removeFeedback);
  const { initModal } = useDetailModalStore((state) => ({
    initModal: state.initModal,
  }));
  const setPopup = usePopup();

  const deleteFeedback = () => {
    setPopup({
      popupTheme: 'negative',
      type: 'confirm',
      title: 'Delete the feedback',
      message:
        'Are you sure you want to delete this feedback? This cannot be undone.',
      confirmText: 'Delete',
      cancelText: 'Cancel',
      onConfirm: async () => {
        try {
          initModal();
          await removeFeedback(feedbackAlias);
          addDefaultToast('Feedback Deleted', 'success');
        } catch (e) {
          addDefaultToast('Feedback Delete Failed', 'fail');
        }
      },
    });
  };

  if (!isEditor) return null;

  return (
    <IconButton
      icon={<Trash2 size={12} />}
      onClick={deleteFeedback}
      tooltip="Delete this feedback"
    />
  );
};
